import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Box, Typography } from '@mui/material';

import type { CMS1500FormData } from '../ClaimCMS1500Form';
import { ClaimRadioGroup, ClaimTextField } from '../fields';

export const Box03_PatientBirthSex: React.FC = () => {
  const { control } = useFormContext<CMS1500FormData>();
  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, flex: 1 }}>
        <Typography variant="caption">3. PATIENT BIRTH DATE</Typography>
        <Controller
          name="patientBirthDate"
          control={control}
          render={({ field, fieldState }) => (
            <ClaimTextField
              field={field}
              fieldState={fieldState}
              type="date"
              size="small"
              fullWidth
            />
          )}
        />
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, flex: '0 0 98px' }}>
        <Typography variant="caption">SEX</Typography>
        <Controller
          name="patientSex"
          control={control}
          render={({ field, fieldState }) => (
            <ClaimRadioGroup
              field={field}
              fieldState={fieldState}
              options={[
                { value: 'M', label: 'M' },
                { value: 'F', label: 'F' },
              ]}
              row
            />
          )}
        />
      </Box>
    </>
  );
};